import React, { useEffect, useMemo, useState } from "react";
import "./transaction.scss";
import moment from "moment";
import { JSONTree } from "react-json-tree";
import {
  Button,
  DatePicker,
  message,
  Modal,
  notification,
  Popover,
  Spin,
  Table,
  Tag,
} from "antd";
import { CalendarOutlined, DownloadOutlined } from "@ant-design/icons";
import { FaAngleDown } from "react-icons/fa";
import { RiCodeSSlashFill, RiCodeSSlashLine } from "react-icons/ri";
import { RiCodeSLine } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import transactionActions from "../../redux/transactions/actions";
import { CSVLink } from "react-csv";
import SearchBar from "../../utils/Searchbar";
import { handleExportFile } from "../../utils/exportTransaction";
import CountUp from "react-countup";
import TransactionExport from "./TransactionExport";
import { Select } from "antd";

const {
  getTransactionsData,
  getAllTransactionsData,
  resetAllTransactionsData,
  getFullTransactionDetails,
  getFullTransactionsDetailsReset,
} = transactionActions;

function Transactions() {
  const dispatch = useDispatch();
  const { fullTransactionDetails, agentId, transactionData } = useSelector(
    (state) => {
      return {
        transactionData: state.transactionReducer.transactionData,
        agentId: state.authReducer.agentId,
        fullTransactionDetails:
          state.transactionReducer?.fullTransactionDetails,
      };
    }
  );

  const { Option } = Select;

  const [api, contextHolder] = notification.useNotification();
  const [copyCount, setCopyCount] = useState(0);

  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  // const [alertNotify, setAlertNotify] = useState(false);
  const [tableParams, setTableParams] = useState({
    current: 1,
    pageSize: 100, // Changed to 100 for default 100 rows
  });
  const [toggleTransactionDetailsModal, setToggleTransactionDetailsModal] =
    useState(true);
  const [toggleTransactionKey, setToggleTransactionKey] = useState("");
  const now = moment();
  const formattedDate = now.format("YYYY-MM-DD");
  const formattedTime = now.format("HH-mm-ss");
  const newFilename = `transactions_data_${formattedDate}_${formattedTime}.csv`;
  const [searchQuery, setSearchQuery] = useState("");
  const [userNotified,setUserNotified]=useState(false)
  const [alertNotify, setAlertNotify] = useState(false);
  const [timeoutId, setTimeoutId] = useState(null);
  const [Status, setStatus] = useState("");
  const [Category, setCategory] = useState("");

  //console.log("searchcategoty,", searchQuery);
  //console.log("category", Category);

  const navigate = useNavigate();

  const HandleChange = () => {
    navigate("/refund");
  };

  const getDynamicColumns = (transactions) => {
    const tags = [];

    // Iterate over all transactions to collect tags
    transactions?.forEach((transaction) => {
      transaction?.customerParams?.tag?.forEach((tag) => {
        // Avoid duplicates by checking if the tag name already exists
        if (!tags.some((existingTag) => existingTag?.name === tag?.name)) {
          tags.push(tag);
        }
      });
    });

    // Map tags to columns
    return tags?.map((tag) => ({
      title: tag?.name,
      dataIndex: tag?.name,
    }));
  };

  // Memoize the dynamic columns to avoid recalculating on every render
  const dynamicColumns = useMemo(
    () => getDynamicColumns(transactionData?.transactions),
    [transactionData]
  );

  const paymentStatus = [
    { text: "Pending", value: "pending" },
    { text: "Successful", value: "successful" },
    { text: "Failure", value: "failure" },
  ];

  const paymentModeOptions = [
    { text: "UPI", value: "upi" },
    { text: "Cash", value: "cash" },
    { text: "Credit Card", value: "credit card" },
    { text: "Account Transfer", value: "account transfer" },
    { text: "Internet Banking", value: "internet banking" },
    { text: "Debit Card", value: "debit card" },
    { text: "Prepaid Card", value: "prepaid card" },
    { text: "IMPS", value: "imps" },
    { text: "Wallet", value: "wallet" },
    { text: "NEFT", value: "neft" },
    { text: "AEPS", value: "aeps" },
    { text: "Others", value: "others" },
  ];

  const billerCategories = [
    { text: "Electricity", value: "electricity" },
    { text: "LPG", value: "lpg" },
    { text: "Gas", value: "gas" },
    { text: "Water", value: "water" },
    { text: "Municipal Taxes", value: "municipal taxes" },
    { text: "Housing Society", value: "housing society maintenance" },
    { text: "Rent", value: "rent" },
    { text: "Landline postpaid", value: "landline postpaid" },
    { text: "Mobile prepaid", value: "mobile prepaid" },
    { text: "Mobile postpaid", value: "mobile postpaid" },
    { text: "FASTag", value: "fastag" },
    { text: "NCMC", value: "ncmc" },
    { text: "Loan repayment", value: "loan repayment" },
    { text: "Credit card", value: "credit card" },
    { text: "Insurance", value: "insurance" },
    { text: "Health Insurance", value: "health insurance" },
    { text: "Recurring Deposit", value: "recurring Deposit" },
    { text: "Education Fees", value: "education fees" },
    { text: "Donation", value: "donation" },
    { text: "National Pension Scheme", value: "national pension scheme" },
    { text: "Broadband Postpaid", value: "broadband postpaid" },
    { text: "Cable TV", value: "cable tv" },
    { text: "DTH", value: "dth" },
    { text: "Subscriptions", value: "subscriptions" },
    { text: "Hospital & Pathology", value: "hospital & pathology" },
    { text: "Hospital", value: "hospital" },
  ];

  const columns = [
    {
      title: "#",
      dataIndex: "key",
      key: "key",
      sorter: (a, b) => a?.key - b?.key,
      width: 100,
    },
    {
      title: "DATE-TIME",
      dataIndex: "date",
      sorter: (a, b) => Date?.parse(a?.createdAt) - Date?.parse(b?.createdAt), // Compare raw date-time
      width: 100, // Fixed width
      render: (text, record) => {
        return (
          <>
            <p className="m-0 p-0">
              {moment(record?.createdAt)?.format("DD MMMM YYYY")}
            </p>
            <p className="m-0 p-0">
              {moment(record?.createdAt)?.format("hh:mm:ss A")}
            </p>
          </>
        );
      },
    },
    {
      title: "TRANSACTION ID",
      dataIndex: "transaction_id",
      sorter: (a, b) => a?.transaction_id?.localeCompare(b?.transaction_id),
      width: 20, // Fixed width
    },
    ...dynamicColumns?.map((item) => ({
      title: item?.title?.toUpperCase(), // Convert title to uppercase
      dataIndex: item?.dataIndex, // Ensure you keep the dataIndex
      width: item?.width || 100, // Use a default width if not provided
    })),

    {
      title: "PAYMENT MODE",
      dataIndex: "payment_mode",
      width: 150,
      filters: paymentModeOptions.map((mode) => ({
        text: mode.text.charAt(0).toUpperCase() + mode.text.slice(1), // Capitalize first letter
        value: mode.value,
      })),
      onFilter: (value, record) => {
        if (value === "others") {
          // ✅ Filter records that do NOT match known modes
          return ![
            "upi",
            "cash",
            "credit card",
            "internet banking",
            "account transfer",
            "debit card",
            "prepaid card",
            "imps",
            "wallet",
            "neft",
            "aeps",
          ].includes(record.payment_mode.toLowerCase());
        }
        return record.payment_mode.toLowerCase() === value.toLowerCase();
      },
      render: (mode) => (
        <Tag>{mode.charAt(0).toUpperCase() + mode.slice(1)}</Tag>
      ),
    },
    {
      title: "BILLER",
      dataIndex: "biller_name",
    },
    // {
    //   title: "BILL AMOUNT",
    //   dataIndex: "billAmount",
    //   sorter: (a, b) => a?.billAmount?.localeCompare(b?.billAmount),
    //   width: 100, // Fixed width
    // },
    {
      title: "PAID AMOUNT",
      sorter: (a, b) =>
        parseFloat(a?.amount?.replace(/[^0-9.-]+/g, "")) -
        parseFloat(b?.amount?.replace(/[^0-9.-]+/g, "")),
      dataIndex: "amount",
    },
    {
      title: "Bank Commision",
      dataIndex: "bankCommission",
    },
    {
      title: "AI Commision",
      dataIndex: "aiCommission",
    },

    {
      title: "BILLER CATEGORY",
      dataIndex: "biller_category_name",
      width: 150,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
        <div style={{ padding: 8 }}>
          <Select
            value={Category}
            showSearch
            style={{ width: 200 }}
            placeholder="Select category"
            optionFilterProp="children"
            onChange={(value) => {
              setSearchQuery(""); // Clear search query when selecting a category
              setCategory(value);
              dispatch(
                getTransactionsData(
                  1,
                  tableParams.pageSize,
                  value, // Use the category value
                  fromDate?.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                  toDate?.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                  agentId,
                  Status
                )
              );
            }}
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
            allowClear
            onClear={() => {
              setCategory("");
              dispatch(
                getTransactionsData(
                  1,
                  tableParams.pageSize,
                  "", // Clear both filters
                  fromDate?.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                  toDate?.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                  agentId,
                  Status
                )
              );
            }}
          >
            {billerCategories.map((category) => (
              <Option key={category.value} value={category.value}>
                {category.text}
              </Option>
            ))}
          </Select>
        </div>
      ),
      onFilter: (value, record) => {
        // Client-side filtering fallback (optional)
        const category = record.biller_category_name?.toLowerCase() || "";
        return category.includes(value.toLowerCase());
      },
    },

    {
      title: "TRANSACTION STATUS",
      dataIndex: "status",
      width: 150, // Fixed width
    },
    {
      title: "FULL TRANSACTION DETAILS",
      dataIndex: "allTransactionDetails",
    },
  ];

  const handleViewTransactionDetails = (data) => {
    dispatch(getFullTransactionDetails(data.refId));
    setToggleTransactionDetailsModal(!toggleTransactionDetailsModal);
    setToggleTransactionKey(data.refId);
  };

  var data =
    transactionData?.data?.transactions &&
    transactionData?.data?.transactions?.length > 0 &&
    transactionData?.data?.transactions?.map((items, index) => {
      const customerTags = items?.customerParams?.tag || [];

      // Create a new object for each row
      const rowData = {
        key: (tableParams.current - 1) * tableParams.pageSize + index + 1,
        transaction_id: items.transactionId,
        // billerId: items?.billerId,
        biller_name: items?.billerName,
        biller_category_name: items?.billerCategoryName,
        payment_mode: items?.paymentMode,
        amount: items?.amount ? `₹${items?.amount / 100}` : "",
        bankCommission: items?.bankCommission
          ? `₹${items?.bankCommission}`
          : "",
        aiCommission: items?.aiCommission ? `₹${items?.aiCommission}` : "",
        billAmount: items?.billAmount ? `₹${items?.billAmount / 100}` : "",
        date: (
          <>
            <p className="m-0 p-0">
              {moment(items?.createdAt).format("DD MMMM YYYY")}
            </p>
            <p className="m-0 p-0">
              {moment(items?.createdAt).format("hh:mm:ss A")}
            </p>
          </>
        ),
        createdAt: items.createdAt,
        status: (
          <Tag
            color={
              items?.status?.toLowerCase() === "successful"
                ? "green"
                : items?.status?.toLowerCase() === "pending" ||
                  items?.cuResponse?.toLowerCase() === "pending"
                ? "yellow"
                : "red"
            }
            className="draft"
          >
            {items?.status?.toLowerCase() === "successful"
              ? "Successful"
              : items?.status?.toLowerCase() === "pending" ||
                items?.cuResponse?.toLowerCase() === "pending"
              ? "Pending"
              : "Failure"}
          </Tag>
        ),
        allTransactionDetails: (
          <span
            onClick={() => handleViewTransactionDetails(items)}
            style={{
              display: "flex",
              justifyContent: "center",
              cursor: "pointer",
            }}
          >
            {toggleTransactionDetailsModal === false &&
            toggleTransactionKey === items?.refId ? (
              <RiCodeSLine size={25} color="#073763" />
            ) : (
              <RiCodeSSlashLine size={25} />
            )}
          </span>
        ),
      };

      // Dynamically add each tag value based on tag name
      customerTags?.forEach((tag) => {
        rowData[tag?.name] = tag?.value;
      });

      return rowData;
    });

  // const handleSearch = (e) => {
  //   e.preventDefault();
  //   const value = e.target.value.trim();
  //    setCategory("")
  //   setSearchQuery(value);

  //   if (timeoutId) {
  //     clearTimeout(timeoutId);
  //   }

  //   const newTimeoutId = setTimeout(() => {
  //     dispatch(
  //       getTransactionsData(
  //         1,
  //         10,
  //         value,
  //         fromDate?.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
  //         toDate?.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
  //         agentId,
  //         Status // Include current status filter
  //       )
  //     );
  //   }, 1000);

  //   setTimeoutId(newTimeoutId);

  //   setTableParams((prev) => ({
  //     current: 1,
  //     pageSize: 10,
  //   }));
  // };

  const handleSearch = (e) => {
    e.preventDefault();
    const value = e.target.value.trim();

    // Clear category when searching
    if (value && Category) {
      setCategory("");
    }

    setSearchQuery(value);

    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    const newTimeoutId = setTimeout(() => {
      dispatch(
        getTransactionsData(
          1,
          tableParams.pageSize,
          value,
          fromDate?.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
          toDate?.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
          agentId,
          Status
        )
      );
    }, 1000);

    setTimeoutId(newTimeoutId);

    setTableParams((prev) => ({
      current: 1,
      pageSize: tableParams.pageSize, // Use current pageSize
    }));
  };

  // const handleStatusChange = (value) => {
  //   setStatus(value); // Update status filter state

  //   dispatch(
  //     getTransactionsData(
  //       1,
  //       tableParams.pageSize,
  //       searchQuery, // Keep existing search query
  //       fromDate?.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
  //       toDate?.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
  //       agentId,
  //       value // Pass status filter
  //     )
  //   );
  // };

  const handleStatusChange = (value) => {
    setStatus(value);
    const filterChange = searchQuery ? searchQuery : Category;
    dispatch(
      getTransactionsData(
        1,
        tableParams.pageSize,
        filterChange, // Include current search
        fromDate?.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
        toDate?.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
        agentId,
        value
      )
    );
  };

  const disabledTime = (currentDate) => {
    const now = moment();
    if (currentDate.isSame(now, "day")) {
      return {
        disabledHours: () =>
          Array.from({ length: 24 }, (_, i) => i).filter(
            (hour) => hour > now.hour()
          ),
        disabledMinutes: (selectedHour) => {
          if (selectedHour === now.hour()) {
            return Array.from({ length: 60 }, (_, i) => i).filter(
              (minute) => minute > now.minute()
            );
          }
          return [];
        },
        disabledSeconds: () => [],
      };
    }
    return {
      disabledHours: () => [],
      disabledMinutes: () => [],
      disabledSeconds: () => [],
    };
  };

  const openNotification = () => {
    sessionStorage.setItem("userNotified", true);
    setUserNotified(sessionStorage.getItem("userNotified"));
    api.open({
      message: (
        <div>
          🎉 You can now{" "}
          <span style={{ fontWeight: "bold", color: "green" }}>
            export the transaction file
          </span>{" "}
          with data filtered by the{" "}
          <span
            style={{
              color: "red",
              fontWeight: "bold",
              textDecoration: "underline",
            }}
          >
            Status
          </span>{" "}
          filter (if selected). Use the status dropdown to refine your export.
        </div>
      ),
      placement: "topRight",
      duration: 5,
      style: {
        width: 600,
      },
      onClose: () => {
        setAlertNotify(false);
      },
    });
    setAlertNotify(true);
  };

  const handlePageChange = async (pagination, filters, sorter) => {
    const { current, pageSize } = pagination;
    setTableParams({ current, pageSize });
    const filterChange = searchQuery ? searchQuery : Category;
    dispatch(
      getTransactionsData(
        current,
        pageSize,
        filterChange,
        fromDate?.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
        toDate?.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
        agentId,
        Status // Include status filter
      )
    );
  };

  const handleFromDateChange = (date) => {
    setFromDate(date);
    if (date > toDate) {
      setToDate(null);
    }
  };

  const handleToDateChange = (date) => {
    if (date?.isAfter(moment(), "day")) {
      setToDate(moment());
    } else if (date?.isSame(moment(), "day")) {
      if (
        date?.isSame(fromDate, "day") &&
        date?.hour() === 0 &&
        date?.minute() === 0 &&
        date?.second() === 0
      ) {
        setToDate(
          date
            .clone()
            .hour(moment().hour())
            .minute(moment().minute())
            .second(moment().second())
        );
      } else if (
        date?.isSame(fromDate, "day") &&
        (date?.hour() > moment().hour() ||
          (date?.hour() === moment().hour() &&
            date?.minute() > moment().minute()) ||
          (date?.hour() === moment().hour() &&
            date?.minute() === moment().minute() &&
            date?.second() > moment().second()))
      ) {
        setToDate(
          date
            .clone()
            .hour(moment().hour())
            .minute(moment().minute())
            .second(moment().second())
        );
      } else if (
        date?.hour() > moment().hour() ||
        (date?.hour() === moment().hour() &&
          date?.minute() > moment().minute()) ||
        (date?.hour() === moment().hour() &&
          date?.minute() === moment().minute() &&
          date?.second() > moment().second())
      ) {
        setToDate(
          date
            .clone()
            .hour(moment().hour())
            .minute(moment().minute())
            .second(moment().second())
        );
      } else {
        setToDate(date);
      }
    } else {
      if (
        date?.isSame(fromDate, "day") &&
        date?.hour() === 0 &&
        date?.minute() === 0 &&
        date?.second() === 0
      ) {
        setToDate(date.clone().hour(23).minute(59).second(59));
      } else {
        setToDate(date);
      }
    }
    if (date && date < fromDate) {
      setFromDate(null);
    }
  };

  const disabledToDate = (current) => {
    return (
      (fromDate && current && current < fromDate?.startOf("day")) ||
      current > moment().endOf("day")
    );
  };

  const disabledDate = (current) => {
    return current && current > moment().endOf("day");
  };

  useEffect(() => {
    dispatch(resetAllTransactionsData());
  }, [agentId, fromDate, toDate, dispatch]);

  useEffect(() => {
    if ((!agentId || agentId === "") && toDate === null && fromDate === null) {
      const filterChange = searchQuery ? searchQuery : Category;

      dispatch(
        getTransactionsData(
          1,
          100,
          filterChange, // Include current search query
          fromDate?.format("YYYY-MM-DD"),
          toDate?.format("YYYY-MM-DD"),
          agentId,
          Status
        )
      );
    } else if (
      (agentId !== null || agentId !== "") &&
      toDate !== null &&
      fromDate !== null
    ) {
      const filterChange = searchQuery ? searchQuery : Category;
      dispatch(
        getTransactionsData(
          1,
          100,
          filterChange, // Include current search query
          fromDate?.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
          toDate?.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
          agentId,
          Status
        )
      );
    } else if (agentId && toDate === null && fromDate === null) {
      const filterChange = searchQuery ? searchQuery : Category;
      dispatch(
        getTransactionsData(
          1,
          100,
          filterChange, // Include current search query
          fromDate?.format("YYYY-MM-DD"),
          toDate?.format("YYYY-MM-DD"),
          agentId,
          Status
        )
      );
    } else if (searchQuery || (Category && Status)) {
      const filterChange = searchQuery ? searchQuery : Category;
      dispatch(
        getTransactionsData(
          1,
          100,
          filterChange, // Include current search query
          fromDate?.format("YYYY-MM-DD"),
          toDate?.format("YYYY-MM-DD"),
          agentId,
          Status
        )
      );
    }

    // else if()
    setTableParams((prev) => ({
      ...prev,
      current: 1,
      pageSize: 100,
    }));
  }, [agentId, dispatch, toDate, fromDate, searchQuery, Category, Status]); // Add searchQuery to dependencies

  useEffect(() => {
    if (toggleTransactionDetailsModal) {
      setCopyCount(0);
    }
  }, [toggleTransactionDetailsModal]);

  const handleCopyClick = () => {
    if (copyCount < 3) {
      navigator?.clipboard
        ?.writeText(
          JSON.stringify(
            fullTransactionDetails?.data !== ""
              ? fullTransactionDetails?.data
              : {}
          )
        )
        ?.then(() => {
          message.success("Copied to clipboard!");
          setCopyCount(copyCount + 1);
        })
        .catch(() => {
          message.error("Failed to copy!");
        });
    }
  };

  // function to close the full transaction details modal
  const handleTransactionDetailsModalClose = () => {
    setToggleTransactionDetailsModal(true);
    dispatch(getFullTransactionsDetailsReset());
  };

  useEffect(() => {
    const filterValue = searchQuery || Category || ""; // Use whichever filter is active

    dispatch(
      getTransactionsData(
        1,
        tableParams.pageSize,
        filterValue,
        fromDate?.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
        toDate?.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
        agentId,
        Status
      )
    );
  }, [
    agentId,
    dispatch,
    toDate,
    fromDate,
    searchQuery,
    Category,
    Status,
    tableParams.pageSize,
  ]);

  return (
    <div className="mainContain">
      {contextHolder}
      <h1 className="transaction">Transactions</h1>
      <div className="d-flex gap-3" style={{ cursor: "pointer" }}>
        {/* <p className="suntag">Transaction</p>
        <p onClick={HandleChange} className="suntaginactive">
          Refund
        </p> */}
      </div>
      <div className="datesearchFi">
        <div className="">
          <SearchBar
            searchInput="Search by ID, Name, Mode, Amount,Category"
            value={searchQuery}
            onChange={handleSearch}
          />
        </div>
        <div className="right-section">
          <div style={{ width: 250 }}>
            <Select
              allowClear
              placeholder="Select Status"
              style={{ width: "100%", height: "43px" }}
              onChange={handleStatusChange}
              // Make it controlled
              options={[
                { label: "Successful", value: "Successful" },
                { label: "Failure", value: "Failure" },
                { label: "Pending", value: "Pending" },
              ]}
            />
          </div>

          <div className="inputfatef">
            <div>
              <DatePicker
                value={fromDate}
                style={{ width: "100%", border: "none" }}
                onChange={handleFromDateChange}
                disabledDate={disabledDate}
                placeholder="From(DD-MM-YYYY HH:mm:ss)"
                showTime
                format="DD-MM-YYYY HH:mm:ss"
                suffixIcon={
                  <CalendarOutlined
                    style={{ color: "rgba(22, 22, 22, 0.25)" }}
                  />
                }
              />
            </div>
            <div>
              <DatePicker
                value={toDate}
                style={{ width: "100%", border: "none" }}
                onChange={handleToDateChange}
                disabledDate={disabledToDate}
                placeholder="To(DD-MM-YYYY HH:mm:ss)"
                showTime={{
                  format: "HH:mm:ss",
                  disabledTime: disabledTime,
                }}
                format="DD-MM-YYYY HH:mm:ss"
                suffixIcon={
                  <CalendarOutlined
                    style={{ color: "rgba(22, 22, 22, 0.25)" }}
                  />
                }
              />
            </div>
          </div>
        </div>
      </div>
      <div className="cardClass">
        <div className="cardpayment">
          <div>Total Payment</div>
          <span>
            <CountUp
              useIndianSeparators={true}
              start={0}
              end={
                transactionData?.loading === true
                  ? 0
                  : transactionData?.data?.totalAmount / 100
              }
              prefix="₹"
            ></CountUp>
          </span>
        </div>
        <div className="cardpayment">
          <div>Total Bank Commision</div>
          <span>
            <CountUp
              useIndianSeparators={true}
              start={0}
              end={
                transactionData?.loading === true
                  ? 0
                  : transactionData?.data?.commission.bankCommission
              }
              prefix="₹"
              decimals={2}
            />
          </span>
        </div>
        <div className="cardpayment">
          <div>Total AI Commision</div>
          <span>
            <CountUp
              useIndianSeparators={true}
              start={0}
              end={
                transactionData?.loading === true
                  ? 0
                  : transactionData?.data?.commission.aiCommission
              }
              prefix="₹"
              decimals={2}
            ></CountUp>
          </span>
        </div>
        <div className="cardpayment">
          <div>Total Transactions</div>
          <span>
            <CountUp
              useIndianSeparators={true}
              start={0}
              end={
                transactionData?.loading === true
                  ? 0
                  : transactionData?.data?.total
              }
              // prefix="Count"
            ></CountUp>
          </span>
        </div>
        <TransactionExport
          Status={Status}
          openNotification={openNotification}
          userNotified={userNotified}
        />
      </div>
      <div className="mt-3">
        <Table
          columns={columns}
          dataSource={data}
          loading={transactionData?.loading}
          scroll={{ x: 600 }}
          pagination={{
            total: transactionData?.data?.total,
            current: tableParams.current,
            pageSize: tableParams.pageSize,
            showSizeChanger: true,
            showQuickJumper: true,
            pageSizeOptions: ["10", "20", "50", "100", "500"],
            defaultPageSize: 100, // Added to ensure 100 rows by default
          }}
          onChange={handlePageChange}
        />
      </div>
      {/* modal for full transaction logs */}
      <Modal
        title="Full Transaction Details"
        open={toggleTransactionDetailsModal === false}
        onOk={handleTransactionDetailsModalClose}
        onCancel={handleTransactionDetailsModalClose}
        width={700}
        centered
        maskClosable={false}
        footer={[
          <Button key="back" onClick={handleTransactionDetailsModalClose}>
            OK
          </Button>,
        ]}
      >
        <div className="py-2" style={{ position: "relative" }}>
          <Button
            key="copy"
            style={{
              position: "absolute",
              top: "20px",
              zIndex: 10,
              right: "30px",
            }}
            onClick={handleCopyClick} // On click, copy the content
            disabled={copyCount >= 3}
          >
            Copy
          </Button>
          <div
            className="bg-white border rounded border-black code-modal-div"
            style={{
              padding: "10px",
              height: "480px",
              overflowY: "auto",
              borderRadius: "10px",
            }}
          >
            {fullTransactionDetails?.loading === true ? (
              <span
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "480px",
                }}
              >
                <Spin />
              </span>
            ) : (
              <>
                {transactionData?.loading === false &&
                fullTransactionDetails?.data !== "" &&
                fullTransactionDetails?.error === null ? (
                  <JSONTree
                    data={
                      fullTransactionDetails?.data !== ""
                        ? fullTransactionDetails?.data
                        : {}
                    }
                    theme={"bright:inverted"}
                  />
                ) : (
                  <JSONTree data={{}} theme={"bright:inverted"} />
                )}
              </>
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default Transactions;
